export enum FS_EVENTS {
  AUTH_ERROR = '[FS]_AUTH_ERROR',
  DIFFERENT_ROBOT_ALERT_OPEN = '[FS]_DIFFERENT_ROBOT_ALERT_OPEN',
  LANGUAGE_CHANGE = '[FS]_LANGUAGE_CHANGE',
}
